export enum PowerUnit {
  'W',
  'kW',
  'MW',
}
